export enum TypeDeDrapeau {
  Vert = 1,
  Jaune = 2,
  Rouge = 3,
  Violet = 4,
  RougeJaune = 5,
  TypeDeDrapeau,
}
